
<script setup>
import { ArrowUpRight, ArrowDownRight } from "lucide-vue-next";

const props = defineProps({
  title: String,
  value: [Number, String],
  icon: [Object, Function],
  trend: Number,
  description: "",
});
const isNegative = props.trend < 0;
</script>

<template>
  <div
    class="bg-white bg-card rounded-2xl shadow p-5 flex flex-col justify-between min-h-[110px]"
  >
    <!-- Header  -->
    <div class="flex items-center gap-2">
      <component
        :is="props.icon"
        class="w-5 h-5"
        :class="
          props.title === 'Total de Estudantes Matriculados'
            ? 'text-blue-600'
            : props.title === 'Total em Dívida'
            ? 'text-red-600'
            : props.title === 'Total Pagamentos Efectuados'
            ? 'text-green-600'
            : props.title === 'Total pago do mês'
            ? 'text-emerald-600'
            : props.title === 'Valor Total de Estudantes Matriculados'
            ? 'text-orange-500'
            : props.title === 'Total de inscrições pendentes'
            ? 'text-red-600'
            : 'text-purple-600'
        "
      />
      <h4 class="text-gray-700 font-medium">{{ props.title }}</h4>
    </div>

    <!-- //Valor  -->
    <div class="text-2xl font-bold text-gray-900 mt-3">{{ props.value }}</div>
    <span>{{ props.description }}</span>
    <!-- // Trend  -->
    <div
      v-if="props.trend !== undefined"
      class="flex items-center gap-1 mt-2 text-sm"
      :class="isNegative ? 'text-red-600' : 'text-green-600'"
    >
      <component
        :is="isNegative ? ArrowDownRight : ArrowUpRight"
        class="w-4 h-4"
      />

      <span>{{ props.trend }}%</span>
    </div>
  </div>
</template>

